import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';

import {
  accountShape,
  availabilityShape,
  bibShape,
  checkedOutItemShape,
  holdItemShape
} from '@bibliocommons/bc-prop-types';
import BibsActions from 'app/actions/BibsActions';
import CheckoutActions from 'app/actions/CheckoutActions';
import HoldActions from 'app/actions/HoldActions';
import ShelfActions from 'app/actions/ShelfActions';
import ModalActions from 'app/actions/ModalActions';
import { selectAllDigitalFormats } from 'app/selectors/bibs/DigitalFormatsSelector';
import { selectCurrentAccount } from 'app/selectors/AuthSelector';
import { selectActiveHoldsByMetadataId, selectHoldsTransactions } from 'app/selectors/HoldsSelector';
import { selectCheckoutsByMetadataId, selectCheckoutTransactions } from 'app/selectors/CheckoutSelector';
import { selectAvailabilityEntities } from 'app/selectors/EntitiesSelector';

import DigitalAccessButton from './DigitalAccessButton';

export class DigitalAccessButtonContainer extends React.PureComponent {
  render() {
    return <DigitalAccessButton {...this.props} />;
  }
}

DigitalAccessButtonContainer.propTypes = {
  bib: bibShape.isRequired,
  isLoading: PropTypes.bool,
  currentAccount: accountShape,
  checkoutItem: checkedOutItemShape,
  holdItem: holdItemShape,
  realtimeAvailability: availabilityShape,
  checkoutTransactions: ImmutablePropTypes.map.isRequired,
  holdsTransactions: ImmutablePropTypes.map.isRequired,
  bibsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  checkoutActions: PropTypes.objectOf(PropTypes.func).isRequired,
  shelfActions: PropTypes.objectOf(PropTypes.func).isRequired,
  holdActions: PropTypes.objectOf(PropTypes.func).isRequired,
  modalActions: PropTypes.objectOf(PropTypes.func).isRequired,
  digitalFormats: ImmutablePropTypes.list
};

const mapStateToProps = (state, ownProps) => {
  const metadataId = ownProps.bib.get('id');
  const holds = selectActiveHoldsByMetadataId(state).get(metadataId, Immutable.List());
  const checkouts = selectCheckoutsByMetadataId(state).get(metadataId, Immutable.List());
  const isLoading = state.getIn(['bibs', 'digitalFormats', metadataId, 'isFetching'], false);

  return {
    isLoading,
    realtimeAvailability: selectAvailabilityEntities(state).get(metadataId),
    digitalFormats: selectAllDigitalFormats(state).get(metadataId),
    currentAccount: selectCurrentAccount(state),
    holdItem: holds.size === 1 ? holds.first() : null,
    checkoutItem: checkouts.first(),
    checkoutTransactions: selectCheckoutTransactions(state),
    holdsTransactions: selectHoldsTransactions(state)
  };
};

const mapDispatchToProps = dispatch => ({
  bibsActions: bindActionCreators(BibsActions, dispatch),
  checkoutActions: bindActionCreators(CheckoutActions, dispatch),
  holdActions: bindActionCreators(HoldActions, dispatch),
  shelfActions: bindActionCreators(ShelfActions, dispatch),
  modalActions: bindActionCreators(ModalActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(DigitalAccessButtonContainer);
